module.exports = __webpack_public_path__ + "img/wp2550138.b2046169.jpeg";